export enum PackagingComponentTypesEnum {
    Undefined,
    MainBody,
    Closure,
    Decoration,
    PackagingAid,
    Inlay
}
